import React from 'react';
import styles from './SharePoster.module.css';

const SharePoster = ({
    config = {
        color: 'Vivid Black 亮黑色',
        stage: 'Stage 2 性能套件',
        style: 'Chrome 风格套件',
        price: '$28,499'
    },
    user = {
        name: 'FatBoy_Rider'
    },
    imageUrl = null
}) => {
    return (
        <div className={styles.container}>
            {/* Header Logo */}
            <div className={styles.header}>
                <div className={styles.logoText}>HARLEY-DAVIDSON</div>
            </div>

            {/* Main Image Area */}
            <div className={styles.mainImageContainer}>
                {imageUrl ? (
                    <img src={imageUrl} alt="Motorcycle Configuration" className={styles.mainImage} />
                ) : (
                    <div className={styles.placeholderText}>
                        [摩托车渲染图]
                        <br />
                        (当前配置状态)
                    </div>
                )}
            </div>

            {/* Title */}
            <div className={styles.titleSection}>
                <h1 className={styles.title}>MY CUSTOM FAT BOY</h1>
            </div>

            {/* Configuration Details */}
            <div className={styles.detailsSection}>
                <div className={styles.detailsHeader}>配置详情:</div>
                <ul className={styles.detailsList}>
                    <li className={styles.detailItem}>{config.color}</li>
                    <li className={styles.detailItem}>{config.stage}</li>
                    <li className={styles.detailItem}>{config.style}</li>
                </ul>
            </div>

            {/* Price */}
            <div className={styles.priceSection}>
                <span className={styles.priceLabel}>总价:</span>
                <span className={styles.priceValue}>{config.price}</span>
            </div>

            {/* QR Code Section */}
            <div className={styles.qrSection}>
                <div className={styles.qrCode}>
                    {/* Placeholder for actual QR Code component */}
                    <div style={{ width: '100%', height: '100%', backgroundColor: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>
                        QR CODE
                    </div>
                </div>
                <div className={styles.qrText}>
                    <span className={styles.qrTitle}>扫码查看我的配置</span>
                    <span className={styles.qrUser}>@{user.name}</span>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <div className={styles.footerText}>HARLEY-DAVIDSON</div>
            </div>
        </div>
    );
};

export default SharePoster;
